import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { GlobalProvider } from "./components/common/Context";
import Firebase from "./components/Firebase";
import LoadingModal from "./components/common/LoadingModal";
import App from "./App.jsx";
import "./index.css";

const firebase = Firebase();

firebase.initFirebase().then(() => {
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <Suspense fallback={<LoadingModal width={6} />}>
        <GlobalProvider fbService={firebase}>
          <App />
        </GlobalProvider>
      </Suspense>
    </StrictMode>,
  );
});
